module.exports = __webpack_public_path__ + "images/circleslider15cdf26d7e876f9aab8929713f6edb92.png";